import React from 'react'
import styles from './Labels.module.css'
import type { LabelJob } from './model'

const headOf = (j: LabelJob) => `${j.site_name} · ${j.variety || 'No variety'}`

// The picking job an item batch carries (§7m.3 stage 2, h 4652-4653): live
// jobs grouped by site and variety, one or none, separate from the workers
// and usable with or without them. It is stored against each item and never
// encoded in the QR. Absent, not disabled, where the subscription does not
// hold Picking job assignment (h 4634-4636); the page does not render it then.
export function JobPicker({
  jobs,
  failed,
  value,
  onChange,
}: {
  jobs: LabelJob[] | null
  failed: string | null
  value: string | null
  onChange: (id: string | null) => void
}) {
  // The read arrives ordered by site, then variety, so a group is a run.
  const heads: { key: string; head: string; jobs: LabelJob[] }[] = []
  for (const j of jobs || []) {
    const key = `${j.site_id}|${j.variety || ''}`
    if (heads.length && heads[heads.length - 1].key === key) heads[heads.length - 1].jobs.push(j)
    else heads.push({ key, head: headOf(j), jobs: [j] })
  }

  return (
    <div className={styles.picker}>
      <div className={styles.jobHead}>
        <span className={styles.jobTitle}>Picking job</span>
        <span className={styles.jobSub}>Stored against the item. Never encoded in the QR.</span>
        <button type="button" className={styles.jobClear} aria-pressed={!value} onClick={() => onChange(null)}>
          No job
        </button>
      </div>
      {failed ? (
        <p className={styles.pickerNote} role="alert">
          {failed}
        </p>
      ) : !jobs ? (
        <p className={styles.pickerNote}>Loading picking jobs…</p>
      ) : !jobs.length ? (
        <p className={styles.pickerNote}>There are no active picking jobs. Jobs are set up in Sites &amp; jobs.</p>
      ) : (
        <div className={[styles.pickerList, styles.jobList].join(' ')} role="radiogroup" aria-label="Picking job">
          {heads.map((g) => (
            <div key={g.key} role="group" aria-label={g.head}>
              <div className={styles.jobGroup}>{g.head}</div>
              {g.jobs.map((j) => (
                <label key={j.id} className={[styles.jobRow, value === j.id ? styles.pickerRowOn : ''].join(' ')}>
                  <input type="radio" className={styles.pickDot} name="label-picking-job" checked={value === j.id} onChange={() => onChange(j.id)} />
                  <span className={styles.pickerText}>
                    <span className={styles.jobName}>{j.name}</span>
                    <span className={styles.pickerGroupName} aria-hidden="true">
                      {j.variety || 'No variety'}
                    </span>
                  </span>
                </label>
              ))}
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
